import TeamFirmCard from '@/components/team-assignments/TeamFirmCard';

/**
 * The "HLB team" tile of the company profile: who works on the client, hand-
 * overs, client status and contacts — the card the old view page showed to
 * HLB staff. What can be changed follows the team-assignments rules on the
 * server; the tile itself is offered to HLB staff only.
 */
export default function CompanyTeamPanel({ companyId }) {
  if (!companyId) return null;
  return (
    <div className="max-w-[900px]">
      <TeamFirmCard companyId={companyId} embedded showBoardLink />
    </div>
  );
}
